<main class="onboarding-container">
	<div class="inner-container mobile-fullscreen">
		<h1>
			<img src="../../../assets/img/iclinic-azul-new.svg" alt="iClinic Pay" class="logo">
		</h1>

		<div class="text">
			<ng-content select="[text-content]"></ng-content>
		</div>

		<div class="form">
			<ng-content select="[form-content]"></ng-content>
		</div>
		<div class="actions" [class.bottom]="atBottom">
			<div class="row">
				<ng-container *ngFor="let action of actions">
					 <div class="col-sm-12">
						<ng-template [ngIf]="action.buttonType==='loading'">
							<loading-button
								[buttonClass]="action.buttonClass"
								[text]="action.text"
								[disabled]="disabled"
								(click)="onClick()"
								[icon]="action.icon"
								[responsive]="true"
								[is-visible]="action.showLoading"
								[keep-text]="true"
								>
							</loading-button>
						</ng-template>
						<ng-template [ngIf]="action.buttonType==='default'">
							<button
								[ngClass]="action.buttonClass + (action.icon ? ' icon':'')"
								[routerLink]="action.routerLink"
                [queryParams]="action.queryParams"
								(click)="onButtonClick(action.callback)"
							>
								<span *ngIf="action.icon" class="material-icons">{{action.icon}}</span>
								{{action.text}}
							</button>
						</ng-template>
					</div>
				</ng-container>
			</div>
		</div>
	</div>

    <p class="onboarding-footer">@2022 iClinic All Rights Reserved.</p>
</main>
